export default "__VITE_ASSET__DHEoVbVs__"